module.exports = __webpack_public_path__ + "img/ros_wijkscan_dashboard.bdf537aa.jpg";